import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.255 12.688A5.98 5.98 0 0 0 8 14a5.98 5.98 0 0 0 3.745-1.312l-1.907-1.907A3.3 3.3 0 0 1 8 11.334c-.68 0-1.311-.204-1.838-.553zM10.781 6.162c.35.527.552 1.159.552 1.838 0 .68-.203 1.311-.552 1.838l1.907 1.907A5.97 5.97 0 0 0 14 8a5.98 5.98 0 0 0-1.312-3.745zM2 8c0-1.417.491-2.718 1.312-3.745l1.907 1.907A3.3 3.3 0 0 0 4.667 8c0 .68.203 1.311.552 1.838l-1.907 1.907A5.98 5.98 0 0 1 2 8M4.255 3.312 6.162 5.22A3.3 3.3 0 0 1 8 4.667c.68 0 1.311.203 1.838.552l1.907-1.907A5.98 5.98 0 0 0 8 2a5.98 5.98 0 0 0-3.745 1.312"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })